// The light on a tilting achievement card (see useCardTilt): a faint foil
// stripe and a glare that move as the card turns. It covers its positioned
// parent and is clipped to the card's corners on its own layer, because
// overflow on the card itself would flatten the depth of its content.

import React from 'react';
import { motion, type MotionValue } from 'framer-motion';

type CardLightProps = {
  glare: MotionValue<string>;
  foilPosition: MotionValue<string>;
};

const CardLight: React.FC<CardLightProps> = ({ glare, foilPosition }) => (
  <div
    aria-hidden="true"
    className="pointer-events-none absolute inset-0 overflow-hidden rounded-xl"
  >
    <motion.div
      className="absolute inset-0 bg-[linear-gradient(115deg,transparent_22%,var(--color-pink-400)_38%,var(--color-sky-400)_47%,var(--color-yellow-300)_56%,var(--color-violet-400)_65%,transparent_80%)] bg-size-[250%_100%] opacity-30 dark:opacity-20"
      style={{ backgroundPosition: foilPosition }}
    />
    <motion.div
      className="absolute inset-0 opacity-70 dark:opacity-25"
      style={{ background: glare }}
    />
  </div>
);

export default CardLight;
